module.exports = __webpack_public_path__ + "img/1378504766.1df6893b.jpg";